import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ADMIN_MENU_GROUPS } from "../config/Adminmenuconfig";
import "./MenubarAdmin.css";

const MenubarAdmin = () => {
  const location = useLocation();

  // ใช้ startsWith แทน === เพื่อให้หน้าลูกแบบ /admin/update-category/:id
  // ยังไฮไลต์เมนู "เพิ่มหมวดหมู่ 360" ค้างไว้ให้เห็นว่าอยู่ในหมวดเดียวกัน
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="navAdmin">
      <div className="navAdmin-brand">
        <span className="navAdmin-brand-title">
          <span className="navAdmin-brand-dot" />
          360 Healthy Shop
        </span>
        <span className="navAdmin-brand-sub">Admin Panel</span>
      </div>

      {ADMIN_MENU_GROUPS.map((group) => (
        <div className="navAdmin-group" key={group.label}>
          <div className="navAdmin-group-label">{group.label}</div>
          <ul className="nav flex-column">
            {group.items.map(({ path, label, icon: Icon }) => (
              <li className="nav-item" key={path}>
                <Link
                  to={path}
                  className={isActive(path) ? "nav-link-active" : ""}
                >
                  <Icon className="nav-item-icon" />
                  <span>{label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};

export default MenubarAdmin;